package com.willandsons.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initContactPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("Contact.md", FrontMatterElement.Builder { addScalar("title", "Contact"); }))
}

@Page("/contact")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun ContactPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("contact-us") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Contact Us")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Email")
        }
        org.jetbrains.compose.web.dom.Text(": ")
        com.varabyte.kobweb.silk.components.navigation.Link("mailto:support@willandsons.com") {
            org.jetbrains.compose.web.dom.Text("support@willandsons.com")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Tel")
        }
        org.jetbrains.compose.web.dom.Text(": +40 744 117 278")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
}
